import { JsonObject, JsonProperty } from 'json2typescript';
import { Opponent } from '../data/opponent';
import { Case } from './case';
import { ClientOppDescription } from './clientOppDescription';

@JsonObject('CaseOpponent')
export class CaseOpponent {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('opponent', Opponent, true)
    opponent: Opponent = null;

    @JsonProperty('description', ClientOppDescription, true)
    description: ClientOppDescription = null;

    // write data
    @JsonProperty('case_id', Number, true)
    caseId: number = undefined;

    @JsonProperty('opponent_id', Number, true)
    opponentId: number = undefined;

    @JsonProperty('description_id', Number, true)
    descriptionId: number = undefined;

    get name() {
        return this.opponent.fullName ? this.opponent.fullName : "—";
    }

    get nameAr() {
        return this.opponent.nameAr ? this.opponent.nameAr : "—";
    }

}

@JsonObject('CaseOpponentLite')
export class CaseOpponentLite {
    @JsonProperty('opponent', String, true)
    opponent: string = null;

    @JsonProperty('description', String, true)
    description: string = null;
}